import { get } from 'services/request';

export interface IVocCategoryWithCount {
  id: number;
  category: string;
  voc_count: number;
}

export default class AIIllustrationVocCategorySelectModel {
  async get(): Promise<IVocCategoryWithCount[]> {
    const response = await get<{ categories: IVocCategoryWithCount[] }>('/ai-illustration/voc-categories');
    return response.categories || [];
  }
}
